import {resourceCmdService, resourceQueryService, resourceQueryServiceUS, resourceQueryServiceAU, resourceQueryServiceAS, responseLogsService} from '../index'

class Resource {
    getServices = id => resourceQueryService.get(`team-service/${id}`)
    addService = data => resourceCmdService.post('service', data)
    updateService = (id, data) => resourceCmdService.put(`service/${id}`, data)
    deleteService = id => resourceCmdService.delete(`service/${id}`)
    addResource = data => resourceCmdService.post('resource', data)
    getResources = id => resourceQueryService.get(`service/${id}/resources`)
    getResource = id => resourceQueryService.get(`resource/${id}`)
    getResourceUS = id => resourceQueryServiceUS.get(`resource/${id}`)
    getResourceAU = id => resourceQueryServiceAU.get(`resource/${id}`)
    getResourceAS = id => resourceQueryServiceAS.get(`resource/${id}`)
    getResourceRegions = id => resourceQueryService.get(`resource/${id}/regions`)
    updateResource = (id, data) => resourceCmdService.put(`resource/${id}`, data)
    deleteResource = ids => resourceCmdService.delete(`resource?${ids}`)
    toggleMonitoringStatus = (id, data) => resourceCmdService.put(`resource/${id}/status`, data)
    toggleResourcesStatus = (ids, data) => resourceCmdService.put(`resources/status?${ids}`, data)
    getResourceSsl = id => resourceQueryService.get(`resource/${id}/ssl`)
    addReminder = (type, id, data) => resourceCmdService.post(`resource/${id}/${type}/reminder`, data)
    updateReminder = (type, id, data) => resourceCmdService.put(`resource/${id}/${type}/reminder`, data)
    deleteReminder = (type, id) => resourceCmdService.delete(`resource/${id}/${type}/reminder`)
    getReminderData = (type, id) => resourceQueryService.get(`resource/${id}/${type}/reminder`)
    getResponseLogs = (id, query) => responseLogsService.get(`resource/${id}/responses${query}`)
    getResourceTld = id => resourceQueryService.get(`resource/${id}/tld`)
    addHeartbeat = data => resourceCmdService.post('heartbeat', data)
    updateHeartbeat = (id, data) => resourceCmdService.put(`heartbeat/${id}`, data)
    getHeartbeats = id => resourceQueryService.get(`service/${id}/heartbeats`)
    getHeartbeat = id => resourceQueryService.get(`heartbeat/${id}`)
    deleteHeartbeats = ids => resourceCmdService.delete(`heartbeat?${ids}`)
    addResourceIntegrations = (id, data) => resourceCmdService.post(`resource/${id}/integration`, data)
    getResourceIntegrations = id => resourceQueryService.get(`resource/${id}/integrations`)
    deleteResourceIntegrations = (id, integration) => resourceCmdService.delete(`resource/${id}/integration/${integration}`)
    addServerResource = data => resourceCmdService.post('server-resource', data)
    getServerResource = id => resourceQueryService.get(`server-resource/${id}`)
    updateServerResource = (id, data) => resourceCmdService.put(`server-resource/${id}`, data)
    getServerResources = id => resourceQueryService.get(`service/${id}/server-resources`)
    deleteServerResource = ids => resourceCmdService.delete(`server-resource?${ids}`)
    getLogGroups = id => resourceQueryService.get(`service/${id}/log-groups`)
    getLogGroup = id => resourceQueryService.get(`/log-group/${id}`)
    deleteLogGroup = id => resourceCmdService.delete(`/log-group/${id}`)
    addLogGroup = data => resourceCmdService.post('log-group', data)
    updateLogGroup = (id, data) => resourceCmdService.put(`/log-group/${id}`, data)
    getRulesetMetricKeys = () => resourceQueryService.get('ruleset-metrics')
    getMetricRulesets = id => resourceQueryService.get(`server-resource/${id}/metric-rulesets`)
}

export default new Resource()
